import type { ButtonProps as ChakraButtonProps } from '@chakra-ui/react';
import { Button as ChakraButton, Spinner } from '@chakra-ui/react';
import React from 'react';

export interface ButtonLoadingProps {
  loading?: boolean;
  loadingText?: React.ReactNode;
}

export interface ButtonProps extends ChakraButtonProps, ButtonLoadingProps {}

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(function Button(props, ref) {
  const { loading, disabled, loadingText, children, ...rest } = props;
  return (
    <ChakraButton disabled={loading || disabled} ref={ref} {...rest}>
      {loading ? (
        <>
          <Spinner size='inherit' color='inherit' />
          {loadingText ?? children}
        </>
      ) : (
        children
      )}
    </ChakraButton>
  );
});
